import React from 'react';
import clsx from 'clsx';
import styles from './ButtonsWrap.module.scss';

type Props = {
  className?: string;
  children: React.ReactNode;
};

const ButtonsWrap = React.forwardRef<HTMLDivElement, Props>((props, ref): JSX.Element => {
  const {
    className,
    children,
    ...other
  } = props;

  return (
    <div
      ref={ref}
      className={clsx(styles.root, className)}
      {...other}
    >
      {children}
    </div>
  );
});

export default React.memo(ButtonsWrap);
